import * as LabelPrimitive from "@radix-ui/react-label";
import { type InputHTMLAttributes, type Ref, useId } from "react";
import { cn } from "./cn.ts";

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly label: string;
  readonly error?: string | undefined;
  readonly hint?: string | undefined;
  readonly ref?: Ref<HTMLInputElement>;
}

/** Ô nhập có nhãn + lỗi gắn aria (a11y). Chữ hiển thị do nơi gọi truyền vào đã qua i18n. */
export function Field({ label, error, hint, className, id, ...props }: FieldProps) {
  const auto = useId();
  const inputId = id ?? auto;
  const describedBy = error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined;
  return (
    <div className="flex flex-col gap-1.5">
      <LabelPrimitive.Root htmlFor={inputId} className="text-sm font-medium text-(--saa-fg)">
        {label}
      </LabelPrimitive.Root>
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={cn(
          "h-9 rounded-md border border-(--saa-border) bg-(--saa-surface) px-3 text-sm text-(--saa-fg) outline-none focus:border-(--saa-ring) focus:ring-2 focus:ring-(--saa-ring)/30",
          error && "border-(--saa-danger)",
          className,
        )}
        {...props}
      />
      {error ? (
        <p id={`${inputId}-error`} role="alert" className="text-xs text-(--saa-danger)">
          {error}
        </p>
      ) : hint ? (
        <p id={`${inputId}-hint`} className="text-xs text-(--saa-fg-muted)">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
